module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_02-Resource_active.f1c6b53e.png";